import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['title', 'description']> = defineContent({
	default: {
		title: {
			id: 'test-messages.test-message-narrow-exposure-experiment.title.no-translate',
			defaultMessage: 'Post Office test message',
			description: 'Heading of the narrow-exposure test message',
			role: 'title',
		},
		description: {
			id: 'test-messages.test-message-narrow-exposure-experiment.description.no-translate',
			defaultMessage: 'This message is used to test narrow-exposure experiments.',
			description: 'Body of the narrow-exposure test message',
			role: 'description',
		},
	},
});
